module.exports = __webpack_public_path__ + "assets/img/sailing-version-qs.ab3402bd.png";